/**
 * @generated SignedSource<<fbd530ce25afa26add6f2b640e1ded4b>>
 * @relayHash 9e80f0af2a06ca7556be63e2d5b2d861
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 267f726090b6308a60e3c379e59368941c64295abfdddf8aa586b38581e014be

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "267f726090b6308a60e3c379e59368941c64295abfdddf8aa586b38581e014be",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
